import { FlatpickrFn } from 'flatpickr/dist/types/instance';
import flatpickr from "flatpickr";
import { getDistance, MapView } from './map';
import { HotelsListResult, Hotel } from './hotels';
import { EventLocation, EventLocationSelector } from './geography';

import { event, timers } from 'jquery';
import { Popover, Tooltip, Tab } from "bootstrap";
import { SignInManager } from "./SignInManager";

export interface StudyOptions {
    //endPointUrl: string;
    listUrl: string;
    scrollContainer: string;
    resultUrl: string;
    //infoWindow: string;    
    hotelInfoWindow: string;
    eventLocationInfoWindow: string;
    map(): MapView;
}

export interface StudyRequest {
    startDate: string;
    endDate: string;
    eventLocationGuid: string;
    radius: Number | 'auto';
    categories: number[][] | any,
    numberOfRooms: Number;
    minNumberOfRooms: Number | 0;
}


export interface IStudy {
    get eventLocation(): EventLocation;
    get period(): { startDate: Date, endDate: Date };
    //get optimalRadius(): number;
    //get numberOfHotels(): number;
    //get totalCapacity(): number;
    //get estimatedRoomsAvailableForEvent(): number;
    //get estimatedRoomsAvailableWithinWalkingDistance(): number;
    //get averagDistance(): number;
    //get maximumDistance(): number;
}

export class Study implements IStudy {


    private _changeTimeOut: NodeJS.Timeout;
    private _options: StudyOptions;


    

    private get _eventLocationGuid(): string {
        return $('#EventLocationGuid').val() as string;
    }
    private get invalidCategoriesMessage(): string {
        switch (document.documentElement.lang) {
            case 'fr':
                return 'Le total doit etre egale a 100%';
            case 'es':
                return 'total categoridas esta no egalato a 100 percento';
            default:
                return 'The sum of the percentages must be exactly 100%.';
        }
    }

    private _radius: Number;

    private _request: StudyRequest;

    constructor(options: StudyOptions) {
        this._options = options;
        const _ = this;

        function updateAsync() {
            _.updateAsync();
        }


        document.addEventListener("DOMContentLoaded", function () {

            _.addCategoriesValidation();

            $('button[name=RadiusButton]').on('click', function () {
                console.log('radius mode changed');
                updateAsync();
            });

            $('.study-radius').on('input', function () {
                console.log('radius value changed');
                updateAsync();
            });

            $('#EventLocationGuid').on('change', function () {
                console.log('radius value changed');
                updateAsync();
            });

            $('#DateRange1').on('change', function () {
                const picker = (document.getElementById("DateRange1") as any)._flatpickr as flatpickr.Instance;
                if (picker.selectedDates.length != 2) return;

                $('#StartDate').val(_.formatDate(picker.selectedDates[0]));
                $('#endDate').val(_.formatDate(picker.selectedDates[0]))

                console.log('dates changed');
                updateAsync();
            });

            $('#NumberOfRooms').on('change', function () {
                console.log('NumberOfRooms changed');
                updateAsync();
            });
            $('#MinNumberOfRooms').on('change', function () {
                console.log('MinNumberOfRooms changed');
                updateAsync();
            });
            $('#nav-all-tab,#nav-percent-tab').on('click', function () {
                console.log('Filter Categories changed');
                updateAsync();
            });

            $('input[name^="Categories["]').on('input change', function () {
                console.log('Categories changed');
                updateAsync();
            })
                        
           
        });        

    }

    private validateDates() {

        
        if (!this.startDate) {
            $("#dateErrors").text("please select a valid date");
            $("#dateErrors").show();
            return false;
        }
        if (!this.endDate) {
            $("#dateErrors").text("please select a valid date");
            $("#dateErrors").show();
            return false;
        }
        
        if (this.endDate <= this.startDate) {            
            $("#dateErrors").text("please select a valid date");
            $("#dateErrors").show();
            return false;
        }

        $("#dateErrors").hide();
        return true;
        
    }

    private validate() {

        const validator = $('#StudyRequestForm').validate();

        if (!validator.valid()) {
            return false;
        }
        if (!this.validateDates()) {
            return false;
        }

        if (document.querySelector('#pills-tab button.active').id === 'nav-percent-tab') {
            return this.validatePercentTotal("Categories");
        }

        return true;      
        
    }


    public get eventLocation(): EventLocation {
        return EventLocationSelector.Instance.selectedEventLocation;
    }

    public get period(): { startDate: Date, endDate: Date } {
        const startDate = new Date($('#StartDate').val() as string);
        const endDate = new Date($('#EndDate').val() as string);
        return { startDate, endDate };
    }

    // Fonction de filtrage
    private filterHotelsByRoomRequirements(
        hotelsList: HotelsListResult,
        totalRoomsRequired: number,
        options?: {
            starDistribution?: number[][]; // Ex: [[4, 0.25], [3, 0.75]]
            distanceMax?: number | 'auto'; // Distance max ou 'auto'
        }
    ): Hotel[] {

        let selectedHotels = hotelsList.hotels;


        selectedHotels.forEach(hotel => {
            hotel.distance = getDistance(hotelsList.center.lat, hotelsList.center.lng, hotel.position.lat, hotel.position.lng);
        });

        let hls = [];
        let i = 0;
        let rooms = 0;
        let roomsByStars = (options && options.starDistribution)
            ? options.starDistribution.map((c: any) => {
                return { stars: c.key, minRooms: Math.ceil(totalRoomsRequired * 2 * Number(c.value / 100)), rooms: 0 };
            }) : null;


        while (i < selectedHotels.length && (totalRoomsRequired * 2) > rooms && (!roomsByStars || !roomsByStars.every(c => c.rooms > c.minRooms))) {

            hls.push(selectedHotels[i]);
            rooms += selectedHotels[i].numberOfRooms;

            if (roomsByStars) {
                const stars = selectedHotels[i].stars;
                const starsIndex = roomsByStars.findIndex(c => c.stars == stars);
                roomsByStars[starsIndex].rooms += selectedHotels[i].numberOfRooms;
            }

            let maxDistance = Math.max(...selectedHotels.map(item => item.distance));
            if (options && options.distanceMax && options.distanceMax !== 'auto' && options.distanceMax < maxDistance) {
                console.warn(
                    `Pas assez de chambres dans ce perimetre`
                );
                break;
            }

            i++;
        }

        selectedHotels = hls;

        let maxDistance = Math.max(...selectedHotels.map(item => item.distance));

        if (options && options.distanceMax && options.distanceMax !== 'auto' && options.distanceMax < maxDistance) {
            console.warn(
                `Pas assez de chambres dans ce perimetre`
            );
        }

        console.log(selectedHotels);

        return selectedHotels;
    }

    public async updateAsync(): Promise<void> {

        const firstLoad = this._changeTimeOut == undefined;
        if (this.validate()) {            
            if (firstLoad || this.synchronize()) {
                clearTimeout(this._changeTimeOut);
                this._changeTimeOut = setTimeout(async () => await this.update(), 500);
            }
        }
    }

    private isMatch(
        hotels: Hotel[],
        options: {
            numberOfRooms: number,
            minNumberOfRooms?: number | null,
            categories?: number[][]; // Ex: [[4, 0.25], [3, 0.75]]
            distanceMax?: number | 'auto'
        }): Boolean {
        var capacity = 0;
        hotels.forEach(h => capacity += h.numberOfRooms);
        return capacity > options.numberOfRooms;
    }

    public async update(): Promise<void> {

        return new Promise((resolve, reject) => {

            $('.map-loader').show();
            $('#map-error').find('.text-danger').text('');
            $('#map-error').hide();

            $('#studyResult').parent().fadeTo(500, 0.18);
             

            var map = this._options.map();
            map.clearMarkers()
               .lazyLoad().then(m => {
                 m.setCenter(this.eventLocation.position);
            });

            map.addSimpleMarker({
                // content: icon,
                //id: this.eventLocationGuid,
                title: this.eventLocation.name,
                position: this.eventLocation.position,
                content: map.defaultMarker,
                //contentUrl: '/' + document.documentElement.lang + '/map/EventLocationPopup',
                allowCluster: false
            });


            return this.searchHotels()
                .then(result => {

                    $('#OptimalRadius').text(formateDistance(result.optimalRadius / 1000));

                    this.addHotelsToMap(result).then(() => {
                        $('.map-loader').hide();
                    });

                    this.loadResult(result);

                    // todo recuperer les data mkg et les dispo booking

                    return result;
                })
                .catch(r => {                    
                    this.displayError(r);
                    
                    $('.map-loader').hide();                    
                    $('#studyLoader').hide();
                });

            function formateDistance(distance) {
                if (distance < 1) {
                    // Convertir en mètres et arrondir à l'entier
                    return Math.round(distance * 1000) + "m";
                } else {
                    // Arrondir à 1 chiffre après la virgule
                    let arrondi = distance.toFixed(1);
                    // Si le chiffre après la virgule est 0, retourner sans virgule
                    return arrondi.endsWith(".0") ? parseInt(arrondi) + "km" : arrondi + "km";
                }
            }

        });
    }

    public async calcOptimalRadius(): Promise<number> {

        var form = document.getElementById("StudyRequestForm") as HTMLFormElement;
        let queryString = `EventLocationGuid=${$('#EventLocationGuid').val()}&numberOfRooms=${$('#NumberOfRooms').val()}`;

        if ($('#nav-percent').hasClass('active')) {

            queryString += ("&" + this.categories.map((val, index) => `Categories[${val.key}]=${encodeURIComponent(val.value)}`).join('&'));
        }

        return $.getJSON(`/Study/CalcOptimalRadius?${queryString}`);
    }

    public get eventLocationGuid(): string {
        return $('#EventLocationGuid').val() as string;
    }

    public get radius(): number | 'auto' {

        if ($('#Radius').is(':visible')) {
            return Number($('#Radius').val() as string);
        }
        return 'auto';
    }

    public get center(): google.maps.LatLngLiteral {
        return EventLocationSelector.Instance.selectedEventLocation.position;
    }

    private get categories(): any {
        if ($('#nav-percent').hasClass('active')) {
            const catValues = [];
            document.querySelectorAll('input[name^="Categories["]')
                .forEach(input => {
                    const __ = input as HTMLInputElement;
                    const itemId = __.getAttribute("itemid");
                    catValues.push({ key: itemId, value: __.value });
                });
            return catValues;
        }
        return null;
    }
    private get starsDistribution(): { [stars: number]: number } {
        const cats = this.categories;
        if (cats == null) return null;

        const values = cats.map(c => { c.stars, c.value / 100 });
        return values;
    }


    private get startDate(): Date {
        const picker = (document.getElementById("DateRange1") as any)._flatpickr as flatpickr.Instance;
        return picker.selectedDates[0];

        //return new Date($("#StartDate").val() as string);
    }
    private get endDate(): Date {
        const picker = (document.getElementById("DateRange1") as any)._flatpickr as flatpickr.Instance;
        if (picker.selectedDates.length > 1) {
            return picker.selectedDates[1];
        }
        return null;
    }
    private get minNumberOfRooms(): number {
        return $("#MinNumberOfRooms").val() as number;
    }

    private get numberOfRooms(): number {
        return $("#NumberOfRooms").val() as number;
    }
    private get activeTab(): string {
        return $("#ActiveTab").val() as string;
    }
    private set activeTab(value:string) {
        $("#ActiveTab").val(value);
    }

    private formatDate(date) {
        if (date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // +1 car les mois vont de 0 à 11
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }
        return date;
    }



    // return true if changed !
    private synchronize(): boolean {


        let params = new URLSearchParams();//(window.location.search)
        const originalQuery = new URLSearchParams( window.location.search); 

        params.set("EventLocationGuid", this.eventLocationGuid);
        params.set("Radius", this.radius.toString());

        if (this.startDate) {
            params.set("StartDate", this.formatDate(this.startDate));
        } else {
            params.delete("StartDate");
        }

        if (this.endDate) {
            params.set("EndDate", this.formatDate(this.endDate));
        } else {
            params.delete("EndDate");
        }

        params.set("NumberOfRooms", this.numberOfRooms.toString());
        if (this.minNumberOfRooms > 0) {
            params.set("MinNumberOfRooms", this.minNumberOfRooms.toString());
        } else {
            params.delete("MinNumberOfRooms");
        }
        var categories = this.categories;
        if (categories != null && categories.length > 0) {
            categories.forEach((c, i) => {

                params.set(`Categories[${c.key}]`, c.value);
            })
        }
        if (this.activeTab) {
            params.set(`tab`, this.activeTab);
        }
        window.history.pushState('object or string', 'Title', "?" + params.toString());

        return originalQuery.toString() !== params.toString();
    }

    private addCategoriesValidation() {

        const _ = this;
        // Ajouter une méthode de validation personnalisée
        $.validator.addMethod("sumto100", function (value, element, params) {
            // Calculer la somme des valeurs des inputs avec data-type="percent"
            var total = 0;
            var group = $(element).data('group');
            var total = _.calcPercentTotal(group);
            return total === 100;

            $('input[data-type="percent"]').each(function () {
                var val = parseFloat($(this).val() as string) || 0;
                total += val;
            });
            return total === 100;
        }, "La somme des pourcentages doit être exactement 100.");

        // Intégrer avec jQuery Unobtrusive Validation
        $.validator.unobtrusive.adapters.add("sumto100", [], function (options) {
            options.rules["sumto100"] = true;
            options.messages["sumto100"] = options.message;
        });
         

        // Attacher la fonction validatePercentTotal à l'événement oninput
        $('input[data-type="percent"]').on('input', function (e) {
            
            _.validatePercentTotal($(this).data('group'));
        });
               

        // Exposer la fonction validatePercentTotal globalement pour l'utiliser dans oninput
        window["validatePercentTotal"] = _.validatePercentTotal;
    }

    // Fonction pour calculer la somme des pourcentages
    private calcPercentTotal(group) {
        var total = 0;
        $('input[data-type="percent"][data-group="' + group + '"]').each(function () {
            var val = parseFloat($(this).val() as string) || 0;
            total += val;
        });
        return total;

    }

    // Fonction pour déclencher la validation manuellement
    public validatePercentTotal(group): boolean {
        group = group ?? "Categories";
        var form = $('form');
        form.validate();
        var isValid = true;
        $('input[data-type="percent"][data-group="' + group + '"]').each(function () {
            if (!$(this).valid()) {
                isValid = false;
            }
        });
        var total = this.calcPercentTotal(group);

        if (total !== 100) {
            //$('input[data-type="percent"]').removeClass('is-valid').addClass('is-invalid');
            this.blinkError('input[data-type="percent"][data-group="Categories"]');
            $('[data-valmsg-for="Categories"]').text(this.invalidCategoriesMessage);
        } else {
            $('[data-valmsg-for="Categories"]').empty();
        }
        return isValid && total === 100;
    }
     

     // Fonction pour clignoter en cas d'erreur
    public blinkError(element) {
        $(element).addClass('error-blink');
        setTimeout(function () {
            $(element).removeClass('error-blink');
        }, 1500);
    }

    private async searchHotels(): Promise<HotelsListResult> {


        const result = await $.post(this._options.listUrl, {
            eventLocationGuid: this.eventLocationGuid,
            radius: this.radius,
            categories: this.categories,
            numberOfRooms: this.numberOfRooms,
            minNumberOfRooms: this.minNumberOfRooms,
            startDate: this.formatDate(this.startDate),
            endDate: this.formatDate(this.endDate),
        }) as HotelsListResult;
        return result;
    }

    private async getrequest(): Promise<StudyRequest> {
        const eventLocationGuid = this.eventLocation.guid;
        const minNumberOfRooms = this.minNumberOfRooms;
        const numberOfRooms = this.numberOfRooms;

        const categories = this.categories;//[[2, 25], [3, 25], [4, 25], [5, 25]];
        const startDate = this.period.startDate;
        const endDate = this.period.endDate;
        const radius = this.radius;

        try {
            const optimalRadius = await this.calcOptimalRadius();

            if (optimalRadius > 1000) {
                $('#OptimalRadius').text(optimalRadius / 1000 + " km");
            } else {
                $('#OptimalRadius').text(optimalRadius + " m");
            }

        } catch (error) {
            throw new Error('Echec du chargement');
        }

        const request: StudyRequest = {
            eventLocationGuid: eventLocationGuid,
            radius: radius,
            minNumberOfRooms: minNumberOfRooms,
            numberOfRooms: numberOfRooms,
            categories: this.categories,



            startDate: startDate.toDateString(),
            endDate: endDate.toDateString()
        };

        return request;

    }

    private async addHotelsToMap(data: HotelsListResult) {
        const _ = this;
        var map = this._options.map();
        $('.map-loader, .list-loader').show();

        var entry = EventLocationSelector.Instance.selectedEventLocation;

        window.localStorage.removeItem("ListHotels");

        window.localStorage.setItem("ListHotels", JSON.stringify(data));

        await map.loadAsync().then(async () => {
            this.addToMap(data).then(() => {
                $('.map-loader').hide();
            });
        });
    }
    private _cancellableRequest: any;

    private async loadResult(data: HotelsListResult): Promise<void> {

        const hotels = data.hotels;
        

        const numberOfHotels = hotels.length;
        const totalCapacity = hotels.reduce((sum, item) => sum + item.numberOfRooms, 0);
        const estimatedCapactity = totalCapacity / 2;
        const numberOfRoomsWithinWalkingDistance = hotels.filter(c => c.distance <= 2)
            .reduce((sum, item) => sum + item.numberOfRooms, 0);

        const averageDisance = hotels
            .map(obj => obj.distance)
            .reduce((sum, num, _, arr) => sum + num / arr.length, 0);

        let maxDistance = Math.max(...hotels.map(item => item.distance));
        this.destroyPopovers();
        $('#sr-numberOfHotels').text(numberOfHotels);
        $('#sr-totalCapacity').text(totalCapacity);
        $('#studyLoader').show();
        

        this._cancellableRequest?.abort();
        
        const _ = this;
        this._cancellableRequest = $.ajax({
            url: '/' + document.documentElement.lang + '/Study/StudyResultPartial?storageKey=' + data.storageKey,
            method: 'POST',
            data: { storageKey: data.storageKey },

            success: function (r) {
                _.destroyPopovers();
                $('#studyResult').replaceWith(r);
                $('#studyResult').parent().fadeTo(800, 1);


                // Si un paramètre 'tab' existe, activer l'onglet correspondant
                if (_.activeTab) {
                    const tabButton = document.querySelector(`#tab-${_.activeTab}`);
                    if (tabButton) {
                        // Utiliser Bootstrap Tab pour activer l'onglet
                        const bsTab = new Tab(tabButton);
                        bsTab.show();
                    }
                }

                // Ajouter un événement pour mettre à jour l'URL lors du changement d'onglet
                document.querySelectorAll('.tab-button').forEach(button => {
                    button.addEventListener('shown.bs.tab', function (e) {
                        const tabId = (e.target as any).id.replace('tab-', '');
                        // Mettre à jour l'URL avec le paramètre 'tab'
                        const newUrl = new URL(window.location.toString());
                        newUrl.searchParams.set('tab', tabId);
                        _.activeTab = tabId;
                        window.history.pushState({}, '', newUrl);
                    });
                });

                _.loadHotelsList(data);
                _.loadTooltips();
                $('#studyLoader').hide();
            },
            error: function (xhr, status, error) {
                if (status === 'abort') {
                    console.log('Requête annulée');
                } else {
                    console.log('Erreur :', error);
                    _.displayError(error);
                }
                $('#studyLoader').hide();
            }
        });
         
    }

    private displayError(error?: string | null) {
        var errorTempate = $('script[data-template="study-error-template"]').text();
        $('#studyResult').html(errorTempate);
        $('#studyResult').parent().fadeTo(800, 1);
        $('#studyLoader').hide();
    }

    // Fonction pour masquer et détruire les popovers
    private destroyPopovers() {
        const popoverElements = document.querySelectorAll('[data-bs-toggle="popover"]');
        popoverElements.forEach(function (element) {
            const popover = Popover.getInstance(element);
            if (popover) {
                popover.hide(); // Masquer le popover
                popover.dispose(); // Détruire l'instance du popover
            }
        });

    }

    private loadTooltips() {
        // Sélectionner tous les éléments avec data-bs-toggle="popover"
        const popoverElements = document.querySelectorAll('[data-bs-toggle="popover"]');

        // Initialiser le popover pour chaque élément
        popoverElements.forEach(function (element) {
            new Popover(element, {
                trigger: 'hover', // Déclencher au survol
                placement: 'top', // Position du popover
                html: true // Permettre du contenu HTML (facultatif)
            });
        });

        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        tooltipTriggerList.forEach(tooltipTriggerEl => {
            new Tooltip(tooltipTriggerEl);
        });

    }

    private async updateStudy(request: StudyRequest): Promise<void> {
        const _ = this;

        //const data: StudyRequest = {
        //    eventLocationGuid: $('#EventLocationGuid').val() as string,
        //    radius: $('#Radius').val() as number,
        //    minNumberOfRooms: $("#MinRooms").val() as number,
        //    numberOfRooms: $("#NumberOfRooms").val() as number,
        //    stars: [[2, 25], [3, 25], [4, 25], [5, 25]],
        //    startDate: $('#StartDate').val() as string,
        //    endDate: $('#EndDate').val() as string
        //};

        //$('#studyResult').replaceWith($('<div id="studyResult" style="min-height:200px;height:100%;display:flex;justify-content:center;align-items:center;"><div class="spinner-grow" role="status"><span class= "visually-hidden" >Loading...</span></div></div>'));
        $('#studyResult').parent().fadeTo(500, 0.18);
        $('#studyLoader').show();
        //$('#studyResult').find('.placeholder-wave').addClass("placeholder");


        // Convertir l'objet data en query string
        const queryString = $.param(request);

        // Construire l'URL complète avec les paramètres
        const url = this._options.resultUrl + "?" + queryString;

        $.post(url)
            .then(function (r, status) {
                if (status === 'success') {
                    $('#studyResult').replaceWith(r);
                    $('#studyResult').parent().fadeTo(800, 1);
                }
                $('.loader').hide();
                $('#studyLoader').hide();
                
            })
            .catch(function (err: any) {
                $('.loader').hide();
                $('#studyResult').html("<div class='text-danger' id='studyResult'>" + err.responseJSON.detail + "</div>")
                $('#studyResult').parent().fadeTo(500, 1);
                $('#studyLoader').hide();
            });
    }
    public async Query(request: StudyRequest): Promise<void> {

        // 
        $.post(this._options.resultUrl)

        return Promise.resolve();
    }


    public async addToMap(data: HotelsListResult): Promise<void> {
        return new Promise(async (resolve, reject) => {

            const mapView = this._options.map();
            const contentUrl = this._options.hotelInfoWindow;
            await mapView.loadAsync();

            const { AdvancedMarkerElement, } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;

            mapView.setCenter(data.center);

            var eventLocationName = $("#EventLocationGuid>option.selected").text();

            await mapView.addSimpleMarkerAsync({
                id: $('#EventLocationGuid').val(),
                position: data.center,
                title: eventLocationName,
                contentUrl: this._options.eventLocationInfoWindow,
                allowCluster: false
            });

            var mapper = function (hotel: Hotel) {

                var div = document.createElement('div');
                div.className = 'hotel-marker stars-' + hotel.stars;

                return {
                    id: hotel.id,
                    position: hotel.position,
                    content: div,
                    contentUrl: contentUrl,
                    allowCluster: true
                };
            }

            var markers = data.hotels.map(mapper);
            await mapView.addSimpleMarkers(markers);
            var bound = mapView.getBounds();

            mapView.fitBounds(bound);
            resolve();
        });


    }

    private loadHotelsList(data: HotelsListResult) {

        const scrollContainer = document.querySelector(this._options.scrollContainer);
        const hotelsList = $('#hotels-list');
        const hotels = data.hotels.map(h => h.id);
        const pageSize = 15;// this.pageSize;
        var pageIndex = 0;// hotelsList.prop('PageIndex');
        

        $('#TotalRecord').text("records : " + hotels.length);

        const eventLocationGuid = EventLocationSelector.Instance.eventLocationGuid;
        const radius = EventLocationSelector.Instance.radius;
        const accommodations = hotels.slice(pageIndex * pageSize, pageSize + (pageIndex * pageSize));

        $.post("/" + document.documentElement.lang + "/hotels/_ListPartial", { eventLocationGuid, radius, accommodations })
            .done(function (data) {
                hotelsList.empty();
                hotelsList[0]?.scrollTo({ top: 0 });
                hotelsList.append($(data));
            })
            .fail(function (err) {
                 
                const error = $(`<div class='alert alert-danger w-100 text-center' role='alert'><i class='fal fa-warning px-1'></i>${err.statusText}</div>`);

                hotelsList.empty().append(error);
            });

        if (hotels.length <= pageSize)
            return;
        

        let isLoading = false;

        $(this._options.scrollContainer).on("scroll", handleScroll);
        $('#hotels-list').on("scroll", handleScroll);

        function handleScroll(el) {

            if (!$('#tab-hotels-content').hasClass('active'))
                return;

            const scrollPosition = scrollContainer.scrollTop + scrollContainer.clientHeight;
            const threshold = scrollContainer.scrollHeight - 300; // 200px avant la fin

            if (scrollPosition >= threshold && !isLoading) {

                pageIndex++;
                

                const accommodations = hotels.slice(pageIndex * pageSize, pageSize + (pageIndex * pageSize));
                if (accommodations.length > 0) {
                    isLoading = true;

                    //const $loader = $('#loading-template').prop('content').cloneNode(true);
                    //$loader.id = 'hotels-list-loader';
                    //hotelsList.append($loader);
                    const loaderHtml = '<div class="w-100 d-flex" style="height:300px">' + document.getElementById('loading-template').innerHTML + '</div>';
                    const loader = $(loaderHtml);                    
                    hotelsList.append(loader);

                    $.post("/" + document.documentElement.lang + "/hotels/_ListPartial", { eventLocationGuid, radius, accommodations })
                        .done(function (data) {
                            requestAnimationFrame(() => {

                                loader.remove();
                                hotelsList.append($(data));
                            });
                            
                        })
                        .fail(function (err) {
                            
                            const error = $(`<div class='alert alert-danger w-100 text-center' role='alert' ><i class='fal fa-warning px-1'></i>${err.statusText}</div>`);

                            hotelsList.empty().append(error);
                        }).always(function () {
                            isLoading = false;
                        });
                }

            }
        }

    }

    public search({ }) {

    }
}

// Attache Study 
window.Study = Study


$('.login-and-start-study').on('click', function () {
    var returnUrl = `/${document.documentElement.lang}/Study/Index${window.location.search}`;

    SignInManager.instance.signIn({ returnUrl: returnUrl });

    // As pointed out in comments,
    // it is unnecessary to have to manually call the modal.
    // $('#addBookDialog').modal('show');
});

$('form.form-start-study').on('submit', function (e) {
    e.preventDefault(); // Empêche la soumission immédiate

    const urlParams = new URLSearchParams(window.location.search);
    const EventLocationGuid = urlParams.get('EventLocationGuid');
    const Radius = urlParams.get('Radius') || '5';

    // Create hidden EventLocationGuid
    const inputEventLocationGuid = document.createElement('input');
    inputEventLocationGuid.type = 'hidden';
    inputEventLocationGuid.name = 'EventLocationGuid';
    inputEventLocationGuid.value = EventLocationGuid;
    this.appendChild(inputEventLocationGuid);

    (this as HTMLFormElement).submit();

});



export class NumberInput {

    /*structure : 
        <number-input> 
            <spin-minus />
            <input-wrapper>
                <input>
            </input-wrapper>
            <spin-plus>
        </number-input>
    */
    
    private _element: HTMLElement;
    private _spinDown: HTMLElement;
    private _wrapper: HTMLElement;
    private _input: HTMLInputElement;
    private _spinUp: HTMLElement;
    constructor(element: HTMLElement) {

        this._element = element;
        this._wrapper = element.querySelector('.input-wrapper');
        this._input = this._wrapper.querySelector('input');
        this._spinDown = element.querySelector('.spin-minus');
        this._spinUp = element.querySelector('.spin-plus');
        this._input.addEventListener('change', function () {


        });
    }

}